import { Fragment, useCallback, useEffect, useRef } from "react";
import { FiLock, FiMail, FiUser, FiX } from "react-icons/fi";
import { FaFacebookF, FaGoogle } from 'react-icons/fa'

import './index.scss'

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { authProps } from "App";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getAuth, tokenExists, updateDestination } from "slices/auth";
import { RootState } from "store";

interface Props {
    SetShowLogin: React.Dispatch<React.SetStateAction<boolean>>
    auth_properties: authProps
    showLogin: boolean
}

export function Authentication(props: Props) {
    const auth = useRef(null)
    const navigate = useNavigate()
    const destination = useAppSelector((state: RootState) => state.auth.destination)
    const dispatch = useAppDispatch()
    const isAuthenticated = useAppSelector(tokenExists)

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/')
        }
    }, [])
    
    const handleCick = useCallback((event: any) => {
        if (event.target.className.startsWith) {
            if (!event?.target.className.startsWith('auth')) {
                props.SetShowLogin(false)
                navigate('/')
            }
        }
    }, [])

    function handleSubmit(event: any) {
        event.preventDefault();
        dispatch(getAuth({ email: 'izuchukwue2@gmail.com', password: 'admin' }))
        if (destination.length > 1) {
            console.log('hehe',destination)
            navigate(destination)
        } else {
            props.SetShowLogin(false)
            console.log('hehe')
            navigate('/')
        }
    }



    return (
        <Fragment>
            <div className={props.showLogin ? "fixed-body" : "fixed-body d-none"} onClick={handleCick}>
                <div className="auth" ref={auth}>

                    <div className="auth-top">
                        <div className="auth-top-title">{props.auth_properties.auth_name}</div>
                        <div className="auth-top-sub-title">{props.auth_properties.auth_title}</div>
                    </div>

                    <form method="post" className="auth-form" onSubmit={handleSubmit}>
                        {props.auth_properties.auth_type === 'register' && (
                            <div className="auth-form-input">
                                <label htmlFor="name" className="auth-form-input-label">name</label>
                                <div className="auth-form-input-container">
                                    <i className="auth-form-input-container-icon"><FiUser /></i>
                                    <input required placeholder="full name" type="text" className="auth-form-input-container-input" id="name" />
                                </div>
                            </div>
                        )}
                        <div className="auth-form-input">
                            <label htmlFor="email" className="auth-form-input-label">email</label>
                            <div className="auth-form-input-container">
                                <i className="auth-form-input-container-icon"><FiMail /></i>
                                {props.auth_properties.auth_type === 'forgot-password' ? (<input required placeholder="your registered email" type="email" className="auth-form-input-container-input" id="email" />) : (<input required placeholder="email" type="email" className="auth-form-input-container-input" id="email" />)}
                            </div>
                        </div>
                        {props.auth_properties.auth_type !== 'forgot-password' && (
                            <div className="auth-form-input">
                                <label htmlFor="password" className="auth-form-input-label">password</label>
                                <div className="auth-form-input-container">
                                    <i className="auth-form-input-container-icon"><FiLock /></i>
                                    <input required placeholder="password" type="password" className="auth-form-input-container-input" id="password" />
                                </div>
                            </div>
                        )}

                        <Link to='/forgot-password' className="auth-form-forgot_password">forgot password ?</Link>
                        <button type="submit" className="auth-form-button">{props.auth_properties.auth_button}</button>
                    </form>
                    <div className="auth-center">
                        or
                    </div>

                    <div className="auth-bottom">
                        <div className="auth-bottom-facebook">
                            <i className="auth-bottom-facebook-icon"><FaFacebookF />
                            </i>
                            <span className="auth-bottom-google-text">login with facebook</span>
                        </div>
                        <div className="auth-bottom-google">
                            <i className="auth-bottom-google-icon"><FaGoogle /></i>
                            <span className="auth-bottom-google-text">login with google</span>
                        </div>
                    </div>
                    <div className="auth-register">
                        {props.auth_properties.auth_comment}
                        <Link to={props.auth_properties.auth_comment_name} className="auth-register-link">{props.auth_properties.auth_comment_name}</Link>
                    </div>
                </div>
                <Link className="auth- close" to='/'>
                    <FiX />
                </Link>
            </div>
            <div className={props.showLogin ? "close-shadow" : "close-shadow d-none"} >
            </div>
        </Fragment>
    )
}